export default __webpack_public_path__ + "static/media/Vikendica 5.0790b7c3.jpeg";